var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.action)?_c('div',[_c(_vm.type,{tag:"component",attrs:{"activity":_vm.activity}}),_c('div',{staticClass:"text-muted"},[_vm._v("\n    "+_vm._s(_vm.formatDate(_vm.activity.created_at))+"\n    by\n    "+_vm._s(_vm.activity.user ? _vm.activity.user.name : "BOLT SYSTEM")+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }